import axios from "axios";
import { accessGlobalUserState } from "../stores/user";
import { unauthorizedExceptions } from "../misc/constants";

export const UNIX_API_HOST = process.env.REACT_APP_UNIX_API_BASE;
export const CARTERA_API_HOST =
  process.env.REACT_APP_CARTERA_API_HOST || "https://uni-q.almv.kz";
export const MAIN_HOST = "http://167.99.133.18:3001";

const makeRequest = async (method, url, apiHost, params, headers = {}) => {
  const apiUrl = `${apiHost}`;
  //console.log('apiUrl: ', apiUrl)
  const userState = accessGlobalUserState().get();
  if (userState.uniqToken) {
    headers.Authorization = `Bearer ${userState.uniqToken}`;
  }
  if (userState.token) {
    headers.MainAuthorization = `Bearer ${userState.token}`;
  }
  const options = {
    url: `${apiUrl}${url}`,
    method,
    headers,
  };

  if (method === "get") {
    options.params = params;
  } else {
    options.data = params;
  }

  return axios(options);
};

const request =
  (method, url, apiHost) =>
  (...params) => {
    //console.log(method, url)

    return makeRequest(method, url, apiHost, ...params)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (
          error.response?.status === 401 &&
          !unauthorizedExceptions.includes(window.location.pathname)
        ) {
          accessGlobalUserState().reset();
          window.location.href = "/admin/login";
        }
        return Promise.reject(error);
      });
  };

const unixRequest = (method, url) => request(method, url, UNIX_API_HOST);

const carteraRequest = (method, url) => request(method, url, CARTERA_API_HOST);

const mainRequest = (method, url) => request(method, url, MAIN_HOST);

const userApi = {
  signIn: (body) => unixRequest("post", "/auth/login")(body),
  search: (query) => unixRequest("get", `/users/search?name=${query}`)(),
  orgAdmin: (body) => unixRequest("post", "/users/roles")(body),
  forgetPassword: (body) => unixRequest("post", "/auth/forget")(body),
  getSelf: () => carteraRequest("get", "/api/v1/users/self")(),
  searchByEmail: (query) =>
    carteraRequest("get", `/api/v1/users/search-by-email?search=${query}`)(),
  findOrCreateMainUser: (body) =>
    carteraRequest("post", `/api/v1/users/find-or-create-main-user`)(body),
  updateRole: (body) =>
    carteraRequest("post", "/api/v1/users/update-role")(body),
  getUsersWithDemerits: () =>
    carteraRequest("get", "/api/v1/users/with-demerits")(),
  getUsersWithSocialScoreAndDemerits: (body) =>
    carteraRequest(
      "post",
      "/api/v1/users/with-social-score-and-demerits"
    )(body),
  getSocialTranscriptScore: (userId) =>
    carteraRequest(
      "get",
      `/api/v1/users/social-transcript-score?user_id=${userId}`
    )(),
  upsertBoard: (body) =>
    carteraRequest("post", "/api/v1/users/upsert-board")(body),
  deleteBoard: (id) =>
    carteraRequest("delete", `/api/v1/users/delete-board/${id}`)(),
  getUsersByExternalIds: (body) =>
    carteraRequest("post", "/api/v1/users/get-users-by-external-ids")(body),
  findByEmails: (body) =>
    carteraRequest("post", "/api/v1/users/find-by-emails")(body),
  getTeacherClasses: () =>
    carteraRequest("get", "/api/v1/users/teacher-classes")(),
  uploadTeacherClasses: (body) =>
    carteraRequest("post", "/api/v1/users/upload-teacher-classes")(body),
};

const lessonsApi = {
  ongoing: (roomName) =>
    carteraRequest("get", `/api/v1/lessons/ongoing?room_name=${roomName}`)(),
  roomsWithLessons: (roomName) =>
    carteraRequest(
      "get",
      `/api/v1/lessons/rooms-with-lessons?room_name=${roomName}`
    )(),
  getById: (id) => carteraRequest("get", `/api/v1/lessons/${id}`)(),
  uploadMedia: (body) =>
    carteraRequest("post", "/api/v1/lessons/upload-media")(body),
  updateGrades: (body) =>
    carteraRequest("post", "/api/v1/lessons/update-grades")(body),
  updateDescription: (body) =>
    carteraRequest("post", "/api/v1/lessons/update-description")(body),
  create: (body) => carteraRequest("post", "/api/v1/lessons/create")(body),
  updateIsAttendanceOngoing: (body) =>
    carteraRequest(
      "post",
      "/api/v1/lessons/update-is-attendance-ongoing"
    )(body),
};

const articlesApi = {
  all: () => carteraRequest("get", "/api/v1/articles/all")(),
  allEvents: () => carteraRequest("get", "/api/v1/cevents/all")(),
};

const universalApi = {
  all: ({ model }) => carteraRequest("get", `/api/v1/universal/${model}/all`)(),
  find: ({ model, body }) =>
    carteraRequest("post", `/api/v1/universal/${model}/find`)(body),
  create: ({ model, body }) =>
    carteraRequest("post", `/api/v1/universal/${model}/create`)(body),
  update: ({ model, body }) =>
    carteraRequest("post", `/api/v1/universal/${model}/update`)(body),
  count: ({ model, body }) =>
    carteraRequest("post", `/api/v1/universal/${model}/count`)(body),
  delete: ({ model, body }) =>
    carteraRequest("post", `/api/v1/universal/${model}/delete`)(body),
};

const newUniversalApi = {
  find: ({ model, body }) =>
    carteraRequest("post", `/api/v1/new-universal/${model}/find`)(body),
  create: ({ model, body }) =>
    carteraRequest("post", `/api/v1/new-universal/${model}/create`)(body),
};

const subjectsApi = {
  create: (body) =>
    carteraRequest("post", "/api/v1/new-universal/Subject/create")(body),
  findAll: (body = {}) =>
    carteraRequest("post", "/api/v1/new-universal/Subject/find")({
      filters: body.filters || {},
      user_params: { skip_user_params: true },
      ...body,
    }),
};

const psychologistAppointmentsApi = {
  create: (body) =>
    carteraRequest("post", "/api/v1/psychologist-appointments/create")(body),
  delete: (id) =>
    carteraRequest(
      "delete",
      `/api/v1/psychologist-appointments/delete/${id}`
    )(),
  copyDaySchedule: (body) =>
    carteraRequest(
      "post",
      "/api/v1/psychologist-appointments/copy-day-schedule"
    )(body),
  getAll: () =>
    carteraRequest("get", "/api/v1/psychologist-appointments/all")(),
  addPsychologistComment: (body) =>
    carteraRequest(
      "post",
      "/api/v1/psychologist-appointments/add-psychologist-comment"
    )(body),
};

const classesApi = {
  uploadStudentsList: (body) =>
    carteraRequest("post", "/api/v1/classes/upload-students-list")(body),
};

const clubsApi = {
  getAll: (clubTypeId) =>
    carteraRequest("get", `/api/v1/clubs/all?club_type_id=${clubTypeId}`)(),
  createClub: (body) => carteraRequest("post", "/api/v1/clubs/create")(body),
  deleteClub: (body) => carteraRequest("post", "/api/v1/clubs/delete")(body),
};

const activitiesApi = {
  createActivity: (body) =>
    carteraRequest("post", "/api/v1/activities/create")(body),
  rejectActivity: (body) =>
    carteraRequest("post", "/api/v1/activities/reject")(body),
  deleteActivity: (id) =>
    carteraRequest("delete", `/api/v1/activities/delete/${id}`)(),
};

const categoriesApi = {
  upsert: (body) => carteraRequest("post", "/api/v1/categories/upsert")(body),
  delete: (body) => carteraRequest("post", "/api/v1/categories/delete")(body),
};

const socialTranscriptApi = {
  createCategory: (body) =>
    carteraRequest("post", "/api/v1/social-transcript/create-category")(body),
  createSubcategory: (body) =>
    carteraRequest(
      "post",
      "/api/v1/social-transcript/create-subcategory"
    )(body),
  deleteModel: ({ model, body }) =>
    carteraRequest("post", `/api/v1/social-transcript/delete/${model}`)(body),
  updateModel: ({ model, body }) =>
    carteraRequest("post", `/api/v1/social-transcript/update/${model}`)(body),
};

const demeritsApi = {
  createDemerit: (body) =>
    carteraRequest("post", "/api/v1/demerits/create-demerit")(body),
  createDisciplinaryCase: (body) =>
    carteraRequest("post", "/api/v1/demerits/create-disciplinary-case")(body),
  updateDisciplinaryCase: (body) =>
    carteraRequest("post", "/api/v1/demerits/update-disciplinary-case")(body),
  rejectDisciplinaryCase: (body) =>
    carteraRequest("post", "/api/v1/demerits/reject-disciplinary-case")(body),
  getDisciplinaryCases: () =>
    carteraRequest("get", "/api/v1/demerits/disciplinary-cases")(),
  upsertDemeritType: (body) =>
    carteraRequest("post", "/api/v1/demerits/upsert-demerit-type")(body),
  deleteDemeritType: (id) =>
    carteraRequest("delete", `/api/v1/demerits/demerit-type/${id}`)(),
  createDisciplinaryHearing: (body) =>
    carteraRequest(
      "post",
      "/api/v1/demerits/create-disciplinary-hearing"
    )(body),
  updateDisciplinaryHearing: (body) =>
    carteraRequest(
      "post",
      "/api/v1/demerits/update-disciplinary-hearing"
    )(body),
  deleteDisciplinaryHearing: (id) =>
    carteraRequest("delete", `/api/v1/demerits/disciplinary-hearings/${id}`)(),
  getDisciplinaryHearings: () =>
    carteraRequest("get", "/api/v1/demerits/disciplinary-hearings")(),
  submitDisciplinaryCaseProtocol: (body) =>
    carteraRequest(
      "post",
      "/api/v1/demerits/submit-disciplinary-case-protocol"
    )(body),
  // Hard delete endpoint
  deleteDemerit: (id) =>
    carteraRequest("delete", `/api/v1/demerits/demerit/${id}`)(),
};

// const mainApi = {
//   auth: (body) => mainRequest('post', '/auth/login')(body),
//   getUsersByExternalId: (body) => mainRequest('post', '/users')(body),
//   getOrganizations: () => mainRequest('get', '/organizations')(),
//   searchInOrganization: ({organizationId, query}) => mainRequest('get', `/users/admins-search/organization/${organizationId}?search=${query}`)()
// }

const mainApi = {
  auth: (body) => carteraRequest("post", "/api/v1/main/auth/login")(body),
  getUserByExternalId: (externalId) =>
    carteraRequest("get", `/api/v1/main/users/${externalId}`)(),
  getUserByEmail: (body) => carteraRequest("post", "/api/v1/main/email")(body),
  getDepartments: () => carteraRequest("get", `/api/v1/main/departments`)(),
  getOrganizations: () => carteraRequest("get", "/api/v1/main/organizations")(),
  searchInOrganization: ({ organizationId, query }) =>
    carteraRequest(
      "get",
      `/api/v1/main/admins-search/organization/${organizationId}?search=${query}`
    )(),
  refreshToken: (body) =>
    carteraRequest("post", "/api/v1/main/auth/refresh-token")(body),
};

const courseApi = {
  getMyCourses: () => carteraRequest("get", "/api/v1/courses/")(),
  create: (body) => carteraRequest("post", "/api/v1/courses/create")(body),
  addStudentsListToClass: (body) =>
    carteraRequest("post", "/api/v1/courses/add-students-list-to-class")(body),
};

const examApi = {
  create: (body) => carteraRequest("post", "/api/v1/exams/create")(body),
};

const certificateApi = {
  signMainUserCertificate: (body) =>
    carteraRequest(
      "post",
      "/api/v1/certificates/sign-main-user-certificate"
    )(body),
  verify: (code) =>
    carteraRequest("post", `/api/v1/certificate-verify/${code}`)(),
};

export {
  userApi,
  articlesApi,
  universalApi,
  newUniversalApi,
  subjectsApi,
  classesApi,
  clubsApi,
  activitiesApi,
  categoriesApi,
  socialTranscriptApi,
  demeritsApi,
  lessonsApi,
  mainApi,
  psychologistAppointmentsApi,
  courseApi,
  examApi,
  certificateApi,
};
